/// <amd-module name="Test/TestPlansLibrary/LibraryHub/Redux/TestPlansLibraryReducer" />
import { default as produce } from "immer";
import { TestPlansLibraryActions, TestPlansLibraryActionsTypes } from "./TestPlansLibraryActions";
import { ITestPlansLibraryState } from "./TestPlansLibraryContracts";

export function TestPlansLibraryReducer(state: ITestPlansLibraryState, action: TestPlansLibraryActions): ITestPlansLibraryState {
    state = state || ({} as ITestPlansLibraryState);

    return produce(state, (draftState: ITestPlansLibraryState) => {});
}
